import { render, staticRenderFns } from "./ConsultarAditivosContrato.vue?vue&type=template&id=712dc7ca&scoped=true"
import script from "./ConsultarAditivosContrato.vue?vue&type=script&lang=ts"
export * from "./ConsultarAditivosContrato.vue?vue&type=script&lang=ts"
import style0 from "./ConsultarAditivosContrato.vue?vue&type=style&index=0&id=712dc7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712dc7ca",
  null
  
)

export default component.exports